import { API_ENDPOINTS } from "../../../Api/apiEndPoints";
import axiosInstance from "../../../Api/axiosInstance"

export const getAgendaList = async(params={})=>{
    let response  =   await axiosInstance.get(API_ENDPOINTS.CONFIGURATION.GET_AGENDA_LIST,{params:params})
    
    const  rowData = await response?.data;
    // console.log('rowData--------------->',rowData);
    const data = Array.isArray(response?.data?.data?.data)?
    response?.data?.data?.data?.map((item:any)=>({
      SurveryIdForAttendeesQuestions:item?.SurveryIdForAttendeesQuestions ||  "-",
      SurveryIdForQuestions:item?.SurveryIdForQuestions || '-',
      AttendeesSurveyName:item?.AttendeesSurveyName  || "-",
      IsPrivate:item?.IsPrivate || '-',
      HasAttendees:item?.HasAttendees || '-',
      Agendaimage: item?.Agendaimage ||'-',
      Agendaid:item?.Agendaid || '-',
      AgendaName: item?.Agendname || '-',
      AgendaControlType:item?.Agendacontroltype || '-',
      // OrgUnitId:item?.Orgunitid ||'-' ,
      OrgUnitName:item?.OrgUnit.UnitName ||'-' ,
      OrgUnitId:item?.OrgUnit.Orgunitid ||'-' ,
      Status: item?.Status ||'-',
    })) : []
    return {data,rowData};
};

export const getAgendaControlType = async ()=>{
    let response = await axiosInstance.get(API_ENDPOINTS.CONFIGURATION.GET_AGENDA_CONTROL_TYPE_LIST);
    const rowData =   await response?.data;

    const data = Object.entries(response?.data?.data|| {}).map(([id,label]:[String,any])=>({
        id: String(id),
        label:String(label)
    }))
      return{data,rowData};
}

export const PostAddAgenda = async(ReqBoady:any)=>{
  const url = `${API_ENDPOINTS.CONFIGURATION.POST_ADD_AGENDA}` 
  let response = await axiosInstance.post(url,ReqBoady);
}

export const PutUpdateAgenda = async(ReqBoady:any)=>{
  
  const url = `${API_ENDPOINTS.CONFIGURATION.PUT_UPDATE_AGENDA}`;
  let response = await axiosInstance.put(url,ReqBoady);
}


export const getAgendaSurveys= async()=>{
   let response = await axiosInstance.get(API_ENDPOINTS.CONFIGURATION.GET_AGENDA_SURVEY);
   const rowData = await response?.data; 
   const formateData = Array.isArray(response?.data?.data)?
     response.data.data.map((item:any)=>({
           id:item.SurveyId,
           label:item.SurveyName
     })) :[]

     return{rowData,formateData};
}

export const getAttendeesSurveys= async()=>{
   
  let response = await axiosInstance.get(API_ENDPOINTS.CONFIGURATION.GET_ATTENDEES_SURVEYS);
  const rowData = await response?.data; 

   const formateData = Array.isArray(response?.data?.data)?
     response.data.data.map((item:any)=>({
           id:item.SurveyId,
           label:item.SurveyName
     })) :[]
     return{rowData,formateData};
}

